const enumEstiloStatus = {
  textoEstilo: "",
  estiloTexto: {
    color: "white",
    background: "rgb(0, 153, 93)",
    "border-radius": "30px",
    padding: "4px 12px",
    width: "66px",
    "text-align": "center"
  }
};

export const enumStatusValidacaoNome = {
  APROVADO_COM_ERRO: "APROVADO_COM_ERRO",
  PROCESSANDO: "PROCESSANDO",
  PENDENTE: "PENDENTE",
  APROVADO: "APROVADO",
  REPROVADO: "REPROVADO",
  ARQUIVO_SUBSTITUIDO: "ARQUIVO_SUBSTITUIDO"
};

export const enumStatusValidacao = {
  [enumStatusValidacaoNome.APROVADO_COM_ERRO]: {
    textoExibicao: "Aprovado com erro",
    textoEstilo: "Aprovado",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#245F40",
      "margin-right": "16px",
      display: "inline-block"
    },
    icones: [
      {
        icone: "alert-triangle",
        tamanho: 20,
        feather: true,
        tooltip: "Aprovado com erro",
        direcaoEsquerda: true,
        style: {
          color: "#ED1651"
        }
      }
    ],
    estiloIcones: {
      display: "inline-block",
      top: "4px",
      position: "relative"
    }
  },
  [enumStatusValidacaoNome.PROCESSANDO]: {
    textoExibicao: "Processando",
    textoEstilo: "Processando",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#9E9E9E"
    }
  },
  [enumStatusValidacaoNome.PENDENTE]: {
    textoExibicao: "Pendente",
    textoEstilo: "Pendente",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      color: "#4D3D02",
      background: "#FFCB08"
    }
  },
  [enumStatusValidacaoNome.APROVADO]: {
    textoExibicao: "Aprovado",
    textoEstilo: "Aprovado",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto
    }
  },
  [enumStatusValidacaoNome.REPROVADO]: {
    textoExibicao: "Reprovado",
    textoEstilo: "Reprovado",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#ED1651"
    }
  },
  [enumStatusValidacaoNome.ARQUIVO_SUBSTITUIDO]: {
    textoExibicao: "Substituído",
    textoEstilo: "Substituído",
    estiloTexto: {
      ...enumEstiloStatus.estiloTexto,
      background: "#7a7e83"
    }
  }
};
